import { useEffect, useState } from "react";
import { StyledStaking, Styles } from "./styles";
import { IoWallet } from "react-icons/io5";
import SWAP_ABI from "abi/SWAP.json";
import STAKING_ABI from "abi/STAKING.json";
import useWindowSize from "hooks/useWindowResize";
import {
  useAccount,
  useContractRead,
  useContractReads,
  useContractWrite,
  useWaitForTransaction,
} from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { formatCurrency, sliceString } from "utils/hepler";
import { formatEther, parseEther } from "viem";
import useApprovalToken from "hooks/useApprovalToken";
import toast from "react-hot-toast";
import Button from "components/Button";
import useGetBalanceToken from "hooks/useGetBalaceToken";

const swapAddress = process.env.REACT_APP_SWAP_ADDRESS as any;
const stakingAddress = process.env.REACT_APP_STAKING_ADDRESS as any;

const Swap = () => {
  const { address } = useAccount();
  const [amountIn, setAmountIn] = useState("");
  const [debouncedValue, setDebounceValue] = useState("");

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebounceValue(amountIn);
    }, 500);
    return () => clearTimeout(delayInputTimeoutId);
  }, [amountIn, 500]);

  const { data: dataConfig, refetch } = useContractReads({
    contracts: [
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "tokenIn",
      },
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "tokenOut",
      },
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "swapFee",
      },
      {
        address: swapAddress,
        abi: SWAP_ABI as any,
        functionName: "tokenInRate",
      },
    ],
  });
  const [tokenIn, tokenOut, fee, rate] = dataConfig ? dataConfig : [];

  const { data: tokenInBalance } = useGetBalanceToken(tokenIn?.result);
  const { data: tokenOutBalance } = useGetBalanceToken(tokenOut?.result);

  const { data: userSwaped = BigInt(0), refetch: reFSwap }: any =
    useContractRead({
      address: swapAddress,
      abi: SWAP_ABI as any,
      functionName: "userSwap",
      args: [address],
      enabled: !!address,
    });
  const { data: userEarned = BigInt(0), refetch: reFEarn }: any =
    useContractRead({
      address: stakingAddress,
      abi: STAKING_ABI as any,
      functionName: "getTotalEarnedAmount",
      args: [address],
      enabled: !!address,
    });

  const available = BigInt(userEarned) - BigInt(userSwaped);

  const { data: dataSwap }: any = useContractRead({
    address: swapAddress,
    abi: SWAP_ABI as any,
    functionName: "getAmountOut",
    args: [parseEther(debouncedValue.toString() as any)],
    enabled: !!debouncedValue,
  });
  const [amountOut, amountfee] = dataSwap ?? ["", ""];

  useEffect(() => {
    let timer = setInterval(() => {
      refetch();
      if (address) {
        reFSwap();
        reFEarn();
      }
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  });

  const {
    allowance,
    isLoading: approveLoading,
    approve,
  } = useApprovalToken(tokenIn?.result, swapAddress);

  const {
    writeAsync: swap,
    data: swapTx,
    isLoading: swapLoading,
  } = useContractWrite({
    address: swapAddress,
    abi: SWAP_ABI as any,
    functionName: "swap",
    onError: (err) => {
      toast.error(err.message);
    },
  });

  const { isSuccess: isSuccessSwap, isLoading: swapLoading2 } =
    useWaitForTransaction({
      hash: swapTx?.hash,
    });

  useEffect(() => {
    if (isSuccessSwap && !swapLoading2) {
      toast.success("Swap successfully!");
      setAmountIn("");
    }
  }, [isSuccessSwap, swapLoading2]);

  const renderBtn = () => {
    if (!address) return <ButtonConnect />;
    if (allowance?.toString() === "0")
      return (
        <Button
          onClick={() => {
            approve();
          }}
          loading={approveLoading}
          className="btn"
        >
          Approve
        </Button>
      );

    const amountSub = parseEther((amountIn ?? 0).toString() as any);
    return (
      <Button
        onClick={() => {
          if (amountSub > available)
            return toast.error("Amount has reached the limit.");
          swap({
            args: [amountSub],
          });
        }}
        loading={swapLoading || swapLoading2}
        disabled={!amountIn || swapLoading || swapLoading2}
      >
        Swap
      </Button>
    );
  };

  return (
    <Styles>
      <div className="container">
        <div className="module">
          <div className="header">
            <p className="title">Swap CATAI</p>
            <ButtonConnect />
          </div>
          <div className="content-module">
            <div className="item-group">
              <StyledStaking>
                <div className="staking-top">
                  <div className="head">
                    <div className="text text-left">Swap amount</div>
                    <div className="text text-right">
                      {formatCurrency(tokenInBalance, 2)} CATAI
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      value={amountIn}
                      type="number"
                      onChange={(e) => {
                        setAmountIn(
                          e.target.value
                            ? (+e.target.value.toString() as any)
                            : ""
                        );
                      }}
                    />
                    <span
                      className="btn-max"
                      onClick={() => {
                        setAmountIn((tokenInBalance as any) ?? "");
                      }}
                    >
                      Max
                    </span>
                    <span className="fee">
                      Available:{" "}
                      {available
                        ? formatCurrency(formatEther(available), 2)
                        : 0}{" "}
                      CATAI
                    </span>
                  </div>
                  <div className="icon-swap">
                    <IconSwap />
                  </div>
                  <div className="head">
                    <div className="text text-left">Receive amount</div>
                    <div className="text text-right">
                      {formatCurrency(tokenOutBalance)} USDT
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      disabled={true}
                      value={
                        amountOut
                          ? formatCurrency(formatEther(amountOut) as any)
                          : ""
                      }
                      onChange={(e) => {}}
                    />
                  </div>
                  <span className="fee">
                    Fee: $
                    {amountfee ? formatCurrency(formatEther(amountfee)) : 0}{" "}
                    USDT
                  </span>
                </div>
                <div className="staking-content">
                  <h3>Infomation:</h3>
                  <div className="card">
                    <div className="card-content">
                      <div className="top">
                        <div className="item">
                          <div className="ct-left">CATAI price:</div>
                          <div className="ct-right">
                            {rate?.status
                              ? +(rate?.result?.toString() || 0) / 1000
                              : 0}{" "}
                            USDT{" "}
                          </div>
                        </div>
                        <div className="item">
                          <div className="ct-left">Fee percent:</div>
                          <div className="ct-right">
                            {fee?.status
                              ? +(fee?.result?.toString() || 0) / 1000
                              : 0}
                            %
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bt">{renderBtn()}</div>
              </StyledStaking>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Swap;

export const ButtonConnect = () => {
  const { width } = useWindowSize();
  const { address } = useAccount();
  return (
    <ConnectButton.Custom>
      {({ openAccountModal, openConnectModal }) => {
        if (!address) {
          return (
            <button
              className="btn_connect btn connect"
              onClick={openConnectModal}
            >
              <IoWallet /> Connect {width > 1300 && "Wallet"}
            </button>
          );
        }
        return (
          <button
            className="button btn_connect"
            onClick={openAccountModal}
            type="button"
          >
            {sliceString(address, 5)}
          </button>
        );
      }}
    </ConnectButton.Custom>
  );
};

const IconSwap = () => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0076FF"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>swap-horizontal-circle-solid</title>{" "}
        <g id="Layer_2" data-name="Layer 2">
          {" "}
          <g id="invisible_box" data-name="invisible box">
            {" "}
            <rect width="48" height="48" fill="none" />{" "}
          </g>{" "}
          <g id="icons_Q2" data-name="icons Q2">
            {" "}
            <path d="M24,2A22,22,0,1,0,46,24,21.9,21.9,0,0,0,24,2ZM11.6,16.6l4.9-5a2.3,2.3,0,0,1,2.7-.3,2,2,0,0,1,.2,3.1L17.8,16H33a2,2,0,0,1,0,4H17.8l1.6,1.6a1.9,1.9,0,0,1-.2,3,2,2,0,0,1-2.7-.3l-4.9-4.9A1.9,1.9,0,0,1,11.6,16.6ZM36.4,31.4l-4.9,4.9a2,2,0,0,1-2.7.3,1.9,1.9,0,0,1-.2-3L30.2,32H15a2,2,0,0,1,0-4H30.2l-1.6-1.6a2,2,0,0,1,.2-3.1,2.3,2.3,0,0,1,2.7.3l4.9,5A1.9,1.9,0,0,1,36.4,31.4Z" />{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
